import { withKlarnaRadioProps } from 'viewModel/checkout/sections/payment/section/klarnaRadio/withKlarnaRadioProps';

import PaymentRadio from 'components/Checkout/Sections/Payment/Section/PaymentRadio';

export default withKlarnaRadioProps(PaymentRadio);
